var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Install",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Install .cls-1 {\n        fill: #33bc12;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1244.602 -344.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_579",
    "data-name": "Pfad 579",
    className: "cls-1",
    d: "M1286.6,428.125a42,42,0,1,1,42-42A42.047,42.047,0,0,1,1286.6,428.125Zm0-79.484a37.484,37.484,0,1,0,37.484,37.484A37.527,37.527,0,0,0,1286.6,348.641Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1692",
    "data-name": "Rechteck 1692",
    className: "cls-1",
    width: 16.258,
    height: 3.613,
    transform: "translate(1278.997 387.804)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1693",
    "data-name": "Rechteck 1693",
    className: "cls-1",
    width: 4.173,
    height: 3.003,
    transform: "translate(1285.038 367.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_581",
    "data-name": "Pfad 581",
    className: "cls-1",
    d: "M1279.1,358.35a7.577,7.577,0,1,0-15.155,0v2.4H1279.1Zm-1.806.6h-11.542v-.6a5.771,5.771,0,1,1,11.542,0Z",
    transform: "translate(15.602 5.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_582",
    "data-name": "Pfad 582",
    className: "cls-1",
    d: "M1278.291,372.125v-6.543h2.511v-6.449h-15.517v6.449h2.493v6.543h-5.708v1.807h21.943v-1.807Zm-11.2-8.349v-2.836H1279v2.836h-2.511v8.237h-6.9v-8.237Z",
    transform: "translate(14.087 12.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_580",
    "data-name": "Pfad 580",
    className: "cls-1",
    d: "M1254.022,383.62a.61.61,0,0,1,.268-.018q3.373.043,6.749.087a5.187,5.187,0,0,0,1.225-.132,1.728,1.728,0,0,0,1.371-1.346,8.289,8.289,0,0,0,.19-2.09c0-.573-.016-1.143-.032-1.716a3.652,3.652,0,0,0-.062-.544,1.781,1.781,0,0,0-1.633-1.573,13.829,13.829,0,0,0-1.895-.067c-1.48-.009-2.959,0-4.438-.005-.564,0-1.127-.043-1.691-.056-.181,0-.2-.054-.132-.213a8.955,8.955,0,0,1,4.743-4.876,9.573,9.573,0,0,1,11.023,2.193,4.512,4.512,0,0,0,.52.513,2.406,2.406,0,0,0,1.481.515q12,.051,24,.036c1.046,0,2.092-.023,3.134.018a5.665,5.665,0,0,1,5.425,5.994,5.565,5.565,0,0,1-2.979,4.648,5.687,5.687,0,0,1-2.724.594q-5.742.022-11.484.025-7.3,0-14.6-.013a4.914,4.914,0,0,0-2.969.807,8.071,8.071,0,0,0-.753.632,8.6,8.6,0,0,1-6.722,2.231,9.546,9.546,0,0,1-6.422-3.134,8.77,8.77,0,0,1-1.535-2.316C1254.053,383.755,1254,383.7,1254.022,383.62Zm46.912-1.7a2.956,2.956,0,0,0-.034-4.021,2.85,2.85,0,0,0-4,.054,2.726,2.726,0,0,0-.043,3.9A2.92,2.92,0,0,0,1300.934,381.92Z",
    transform: "translate(7.504 21.015)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download_pdf.73adf800a21a73bc1891d565769bff6c.svg";
export { ForwardRef as ReactComponent };